export default "__VITE_ASSET__ClwZymAd__"